import createAxiosInstance from './axiosConfig';
import { PromotoraDTO } from '../shared/dto/promotoraDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/promotoraController');

export default class PromotoraService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasPromotorasAtivas() {
    return await this.axios.get(`/listarTodasPromotorasAtivas`);
  };

  async listarTodasPromotorasAquisicao(){
    return await this.axios.get(`/listarTodasPromotorasAquisicao`);
  };

  async listarTodasPromotorasAtivasPorRole() {
    return await this.axios.get(`/listarTodasPromotorasAtivasPorRole`);
  };

  async listarTodasPromotoras(page = 0, size = 10, filtros: any) {
    return this.axios.post(`/listarTodasPromotoras`, filtros, {
      params: { page, size }
    });
  }

  async listarTodasPromotorasPorRole() {
    return await this.axios.get(`/listarTodasPromotorasPorRole`);
  };

  async ativarInativarPromotora(id: string) {
    return await this.axios.get(`/ativarInativarPromotora?id=${id}`);
  };

  async listarPromotoraPorId(id: string) {
    return await this.axios.get(`/listarPromotoraPorId?id=${id}`);
  };

  async incluirAlterarPromotora(dto: PromotoraDTO) {
    return await this.axios.post(`/incluirAlterarPromotora`, dto);
  };

  async buscarPorOriginador(idsOriginadores: any[]) {
    return await this.axios.post(`/buscarPorOriginador`, idsOriginadores);
  };

}